import React from 'react';
import { LoginForm } from 'components';
export const LoginPage = () => {
	return <LoginForm />;
};